export const imports = {
  'introduction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "introduction" */ 'introduction.mdx'
    ),
  'components/Avatar/avatar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-avatar-avatar" */ 'components/Avatar/avatar.mdx'
    ),
  'components/Button/button.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-button-button" */ 'components/Button/button.mdx'
    ),
  'components/ButtonGroup/button_group.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-button-group-button-group" */ 'components/ButtonGroup/button_group.mdx'
    ),
  'components/Checkbox/checkbox.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-checkbox-checkbox" */ 'components/Checkbox/checkbox.mdx'
    ),
  'components/Stars/stars.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-stars-stars" */ 'components/Stars/stars.mdx'
    ),
}
